import React, { useEffect, useState } from 'react'
import NetaqInput from './NetaqInput'
import { useTranslate } from './TranslationText'
import SimpleFileUpload from './SimpleFileUpload';
import CustomButton from './CustomButton';
import Loader from './Loader';
import axiosBackend from '../axios/axios';
import { convertToCamelCase } from '../helper/convertToCamelCase';



export default function RegisterForm({ toast, setShowOTP, setEmail, setPassword }) {
    const { translate } = useTranslate();
    const [uploadedFiles, setUploadedFiles] = useState([]);
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [registrationObject, setRegistrationObject] = useState({ gender: 1 });
    const [countries, setCountries] = useState([]);
    const [cities, setCities] = useState([]);
    const [currencies, setCurrencies] = useState([]);
    const [currency, setCurreny] = useState([]);
    const [nationality, setNationality] = useState([]);
    const [country, setCountry] = useState([]);
    const [city, setCity] = useState([]);
    const [bankCountry, setBankCountry] = useState([]);
    const [invalidIban, setInvalidIBAN] = useState(false);
    const currentLanguage = localStorage.getItem('ecupLang') ?? 'en';

    const maxDate = `${new Date().getFullYear()}-${new Date().getMonth()}-${new Date().getDate()}`;


    // upload ID File
    const handleFilesUploaded = (e) => {
        if (e.target.files && e.target.files.length > 0) {
            let checkFileSize = true;
            const fileListHook = [];

            for (let fileIndex = 0; fileIndex < e.target.files.length; fileIndex++) {
                if (e.target.files[fileIndex].size > 10 * 1024 * 1024) {
                    checkFileSize = false;
                    toast.error(translate("web.fileSizeLimit", "File size 10MB limit."));
                } else {
                    // Check allowed file types
                    const file = e.target.files[fileIndex];
                    const allowedMimeTypes = ['image/', 'application/pdf'];
                    if (!allowedMimeTypes.some(type => file.type.startsWith(type))) {
                        toast.error(translate("web.invalidFileType", "Only images and PDFs allowed."));
                        continue; // Skip to the next file if type is not allowed
                    }
                    fileListHook.push({
                        documentFile: URL.createObjectURL(e.target.files[fileIndex]),
                        name: e.target.files[fileIndex].name,
                        file: e.target.files[fileIndex],
                    });
                }
            }

            setUploadedFiles(fileListHook);
        }
    };

    const handleChange = (e) => {
        if (e.target.name == 'email') {
            setEmail(e.target.value);
        }
        if (e.target.name == 'password') {
            setPassword(e.target.value);
        }
        setRegistrationObject((prev) => ({
            ...prev,
            [e.target.name]: e.target.value
        }));
    }

    const [isPhoneNumberValid, setIsPhoneNumberValid] = useState(true);
    const setPhoneNumber = (value) => {
        setRegistrationObject((prev) => ({
            ...prev,
            'phone': value
        }));
    }



    const submitForm = async (e) => {
        e.preventDefault();
        if (!!!registrationObject?.fullName ?? true) {
            toast.error(`${translate('web.fullName', 'Full Name Is Required')} ${translate('web.isRequired')}`);
            return;
        }
        if (!!!registrationObject?.fullNameAr ?? true) {
            toast.error(`${translate('web.fullNameAr', 'Full Name Arabic Is Required')} ${translate('web.isRequired')}`);
            return;
        }
        if (registrationObject?.password != registrationObject?.confirmPassword ?? true) {
            toast.error(`${translate('web.passwordsAreNotMatched', 'Passwords Are Not Matched')}`);
            return;
        }
        if (!!!registrationObject?.password ?? true) {
            toast.error(`${translate('web.password', 'Password is Required')} ${translate('web.isRequired')}`);
            return;
        }
        if (!!!registrationObject?.confirmPassword ?? true) {
            toast.error(`${translate('web.confirmPassword', 'Confirm Password is Required')} ${translate('web.isRequired')}`);
            return;
        }
        if (!!!registrationObject?.phone ?? true) {
            toast.error(`${translate('web.phone', 'Phone is Required')} ${translate('web.isRequired')}`);
            return;
        }
        if (!!!registrationObject?.birthDate ?? true) {
            toast.error(`${translate('web.birthdate', 'BirthDate is Required')} ${translate('web.isRequired')}`);
            return;
        }
        if (!!!registrationObject?.address ?? true) {
            toast.error(`${translate('web.street', 'Address is Required')} ${translate('web.isRequired')}`);
            return;
        }
        if (!!!registrationObject?.bankAccount ?? true) {
            toast.error(`${translate('web.iban', 'IBAN is Required')} ${translate('web.isRequired')}`);
            return;
        }
        if (!!!registrationObject?.bankAccountNumber ?? true) {
            toast.error(`${translate('web.bankAccountNumber', 'bankAccountNumber is Required')} ${translate('web.isRequired')}`);
            return;
        }
        if ((!!!registrationObject?.bankName && !invalidIban) ?? true) {
            toast.error(`${translate('web.bankName', 'Bank Name is Required')} ${translate('web.isRequired')}`);
            return;
        }
        if (!!!registrationObject?.idNumber ?? true) {
            toast.error(`${translate('web.passportNumber', 'Id Number is Required')} ${translate('web.isRequired')}`);
            return;
        }

        if (!!!registrationObject?.swiftCode ?? true) {
            toast.error(`${translate('web.swiftCode', 'Swift Code is Required')} ${translate('web.isRequired')}`);
            return;
        }
        if (nationality.length == 0) {
            toast.error(`${translate('web.nationality', 'Nationality is Required')} ${translate('web.isRequired')}`);
            return;
        }
        if (currency.length == 0) {
            toast.error(`${translate('web.currency', 'Currency is Required')} ${translate('web.isRequired')}`);
            return;
        }
        if (bankCountry.length == 0) {
            toast.error(`${translate('web.bankCountry', 'Bank Country is Required')} ${translate('web.isRequired')}`);
            return;
        }
        if (uploadedFiles.length == 0) {
            toast.error(`${translate('web.passportCopy', 'Passport Copy is Required')} ${translate('web.isRequired')}`);
            return;
        }
        if (!country?.value ?? true) {
            toast.error(`${translate('web.city', 'City is Required')} ${translate('web.isRequired')}`);
            return;
        }
        if (!city?.value ?? true) {
            toast.error(`${translate('web.city', 'City is Required')} ${translate('web.isRequired')}`);
            return;
        }
        const fromData = new FormData();
        // loop on object
        for (const key in registrationObject) {
            if (registrationObject.hasOwnProperty(key)) {
                fromData.append(key, registrationObject[key]);
            }
        }
        fromData.append('currency', currency.value);
        fromData.append('bankCountryId', bankCountry.value);
        fromData.append('nationalityId', nationality.value);
        fromData.append('CountryId', country?.value);
        fromData.append('cityId', city?.value);
        fromData.append('File', uploadedFiles[0].file);
        fromData.append('idType', 1);
        fromData.append('accountType', 1);
        fromData.append('accountCategory', 1);

        try {
            setIsSubmitting(true);
            const res = await axiosBackend.post('/api/Account/register', fromData, {
                headers: {
                    'content-type': 'multipart/form-data',
                }
            });
            if (res?.data?.responseCode == "200") {
                toast.success(translate('web.anEmailHasBeenSentWithOTP', 'An Email Has Been Sent With OTP'));
                setIsSubmitting(false);
                setShowOTP(true);
            } else {
                toast.error(translate(`web.${convertToCamelCase(res?.data?.responseText)}`, res?.data?.responseText));
                setIsSubmitting(false);
            }

        } catch (error) {
            toast.error(translate('web.errorInRegistrationPleaseContactTheAdmin', 'Error In Registration Please Contact The Admin') + " error:" + error);
            setIsSubmitting(false);
        }

    }


    // get Lists Data
    async function getCountries() {
        const response = await axiosBackend.get('/api/Lookup/GetCountries');
        const formattedData = response?.data?.result.map((x) => ({
            text: currentLanguage == 'en' ? x.name : x.arName,
            value: x.id,
            ...x
        }))
        setCountries(formattedData);
    }

    // get Cities Data
    async function getCities(CountryId) {
        const response = await axiosBackend.get(`/api/Lookup/GetCitybyCountryId?id=${CountryId}`);
        const formattedData = response?.data?.result.map((x) => ({
            text: currentLanguage == 'en' ? x.name : x.nameAr,
            value: x.id,
            ...x
        }))
        setCities(formattedData);
    }

    async function GetCurrencies() {
        const response = await axiosBackend.get('/api/Lookup/GetCurrencies');
        const formattedData = response?.data?.result.map((x) => ({
            text: x.text,
            value: x.value,
            ...x
        }))
        setCurrencies(formattedData);
    }


    useEffect(() => {
        GetCurrencies();
        getCountries();
    }, []);

    useEffect(() => {
        if ((registrationObject?.bankAccount?.length < 14 || registrationObject?.bankAccount?.length > 35) ?? false) {
            setInvalidIBAN(true);
        } else {
            setInvalidIBAN(false);
        }
    }, [registrationObject]);

    return (
        <>

            <form className='' onSubmit={submitForm} >
                <div className='row mx-0 my-2 py-3 borderGray border-raduis-15-px'>
                    <h4 className='mainColor font-weight-bold' >{translate('web.basicInformation', 'Basic Information')}</h4>
                    <div className='col-lg-6 col-md-6 col-sm-12 mt-2' >
                        <NetaqInput
                            type={'text'}
                            label={translate('web.fullName', 'Full Name')}
                            name={'fullName'}
                            placeholder={translate('web.fullName', 'Full Name')}
                            required={true}
                            onChange={handleChange}
                        />
                    </div>
                    <div className='col-lg-6 col-md-6 col-sm-12 mt-2' >
                        <NetaqInput
                            type={'text'}
                            label={translate('web.fullNameAr', 'Full Name Arabic')}
                            name={'fullNameAr'}
                            placeholder={translate('web.fullNameAr', 'Full Name Arabic')}
                            required={true}
                            onChange={handleChange}
                        />
                    </div>
                    <div className='col-lg-6 col-md-6 col-sm-12 mt-2' >
                        <NetaqInput
                            type={'email'}
                            label={translate('web.email', 'Email')}
                            name={'email'}
                            placeholder={'mail@mail.com'}
                            required={true}
                            onChange={handleChange}
                        />
                    </div>
                    <div className='col-lg-6 col-md-6 col-sm-12 mt-2' >
                        <NetaqInput
                            type={'phone'}
                            label={translate('web.mobileNumber', 'Mobile Number')}
                            name={'phone'}
                            placeholder={'971xxxxxxxxx'}
                            required={true}
                            onChange={setPhoneNumber}
                            setIsPhoneNumberValid={setIsPhoneNumberValid}
                        />
                        {!isPhoneNumberValid &&
                            <div className='text-danger'>
                                {translate('web.phoneNumberIsNotValid', 'Phone Number Is Not Valid')}
                            </div>
                        }
                    </div>
                    <div className='col-lg-6 col-md-6 col-sm-12 mt-2' >
                        <NetaqInput
                            type={'normalDate'}
                            label={translate('web.birthdate', 'birthDate')}
                            name={'birthDate'}
                            placeholder={'************'}
                            required={true}
                            maxDate={maxDate}
                            value={registrationObject.birthDate}
                            onChange={handleChange}
                        />
                    </div>
                    <div className='col-lg-6 col-md-6 col-sm-12 mt-2' >
                        <label className="capatalize_text">
                            {translate('web.gender', 'Gender')} :
                        </label>
                        <div className="row mx-0 rtl">
                            <div className="col-lg-6 col-md-6 col-sm-6 align-content-center">
                                <NetaqInput
                                    type={"radio"}
                                    label={translate('web.male', 'Male')}
                                    name={"gender"}
                                    value={1}
                                    checked={true}
                                    onChange={handleChange}
                                />
                            </div>
                            <div className="col-lg-6 col-md-6 col-sm-6 align-content-center" >
                                <NetaqInput
                                    type={"radio"}
                                    label={translate('web.female', 'Female')}
                                    name={"gender"}
                                    value={2}
                                    onChange={handleChange}
                                />
                            </div>
                        </div>
                    </div>
                    <div className="col-lg-6 col-md-6 col-sm-12 mt-2">
                        {countries.length > 0 &&
                            <NetaqInput
                                key={'countries'}
                                type={"select"}
                                label={translate("web.nationality", "Nationality")}
                                placeholder={translate("web.nationality", "Nationality")}
                                name={"nationalityId"}
                                listSelect={countries}
                                value={nationality}
                                onChange={(item) => setNationality(item)}
                                required={true}
                            />
                        }
                    </div>
                    <div className="col-lg-6 col-md-6 col-sm-12 mt-2">
                        {countries.length > 0 &&
                            <NetaqInput
                                key={'country'}
                                type={"select"}
                                label={translate("web.country", "Country")}
                                placeholder={translate("web.country", "Country")}
                                name={"countryId"}
                                listSelect={countries}
                                value={country}
                                onChange={(item) => { setCountry(item); setCity({ label: translate('web.selectCity', 'Select City') }); getCities(item?.value) }}
                                required={true}
                            />
                        }
                    </div>
                    <div className="col-lg-6 col-md-6 col-sm-12 mt-2">
                        <NetaqInput
                            key={'city'}
                            type={"select"}
                            label={translate("web.city", "City")}
                            placeholder={translate("web.city", "City")}
                            name={"cityId"}
                            disabled={cities.length <= 0}
                            listSelect={cities}
                            value={city}
                            onChange={(item) => setCity(item)}
                            required={true}
                        />
                    </div>
                    <div className="col-lg-6 col-md-6 col-sm-12 mt-2">
                        <NetaqInput
                            type={"text"}
                            label={translate("web.street", "Street")}
                            placeholder={translate("web.street", "Street")}
                            name={"address"}
                            key={"address"}
                            onChange={handleChange}
                            required={true}
                        />
                    </div>
                    <div className='col-lg-6 col-md-6 col-sm-12 mt-2' >
                        <NetaqInput
                            type={'password'}
                            label={translate('web.password', 'Password')}
                            name={'password'}
                            placeholder={'************'}
                            required={true}
                            onChange={handleChange}
                        />
                        {((registrationObject?.password != registrationObject?.confirmPassword) ?? false) &&
                            <span className='text-danger' > {translate('web.passwordsAreNotMatch', 'Passwords Are Not Match')} </span>
                        }
                    </div>
                    <div className='col-lg-6 col-md-6 col-sm-12 mt-2' >
                        <NetaqInput
                            type={'password'}
                            label={translate('web.confirmPassword', 'Confirm Password')}
                            name={'confirmPassword'}
                            placeholder={'************'}
                            required={true}
                            onChange={handleChange}
                        />
                    </div>
                    <h4 className='mainColor font-weight-bold mt-3' >{translate('web.bankAccountDetails', 'Bank Account Details')}</h4>
                    <div className="col-lg-6 col-md-6 col-sm-12 mt-2">
                        <NetaqInput
                            type={"text"}
                            label={translate("web.bankName", "Bank Name")}
                            placeholder={translate("web.bankName", "Bank Name")}
                            name={"bankName"}
                            key={"Bank Name"}
                            onChange={handleChange}
                            required={true}
                        />
                    </div>
                    <div className="col-lg-6 col-md-6 col-sm-12 mt-2">
                        <NetaqInput
                            type={"text"}
                            label={translate("web.beneficiaryName", "Beneficiary Name")}
                            placeholder={translate("web.beneficiaryName", "Beneficiary Name")}
                            name={"beneficiaryName"}
                            key={"beneficiaryName"}
                            onChange={handleChange}
                            value={registrationObject?.fullName}
                            required={true}
                            disabled={true}
                        />
                    </div>
                    <div className="col-lg-6 col-md-6 col-sm-12 mt-2">
                        <NetaqInput
                            type={"text"}
                            label={translate("web.iban", "IBAN")}
                            placeholder={translate("web.iban", "Iban")}
                            name={"bankAccount"}
                            key={"IBAN"}
                            onChange={handleChange}
                            required={true}
                        />
                        {invalidIban &&
                            <div className='text-danger text-center'>
                                {translate('web.invalidIban', 'Invalid IBAN')}
                            </div>
                        }
                    </div>
                    <div className="col-lg-6 col-md-6 col-sm-12 mt-2">
                        <NetaqInput
                            type={"text"}
                            label={translate("web.bankAccountNumber", "bank Account Number")}
                            placeholder={translate("web.bankAccountNumber", "bank Account Number")}
                            name={"bankAccountNumber"}
                            key={"bankAccountNumber"}
                            onChange={handleChange}
                            required={true}
                        />
                    </div>
                    <div className="col-lg-6 col-md-6 col-sm-12 mt-2">
                        <NetaqInput
                            type={"text"}
                            label={translate("web.swiftCode", "SWIFT Code")}
                            placeholder={translate("web.swiftCode", "SWIFT Code")}
                            name={"swiftCode"}
                            key={"swiftCode"}
                            onChange={handleChange}
                            required={true}
                        />
                    </div>
                    <div className="col-lg-6 col-md-6 col-sm-12 mt-2">
                        <NetaqInput
                            key={'Currency'}
                            type={"select"}
                            label={translate("web.currency", " Currency")}
                            placeholder={translate("web.currency", " Currency")}
                            name={"currency"}
                            listSelect={currencies}
                            value={currency}
                            onChange={(item) => setCurreny(item)}
                            required={true}

                        />
                    </div>
                    <div className="col-lg-6 col-md-6 col-sm-12 mt-2">
                        {countries.length > 0 &&
                            <NetaqInput
                                key={'bankCountry'}
                                type={"select"}
                                label={translate("web.bankCountry", "Bank Country")}
                                placeholder={translate("web.bankCountry", "Bank Country")}
                                name={"bankCountry"}
                                listSelect={countries}
                                value={bankCountry}
                                onChange={(item) => setBankCountry(item)}
                                required={true}
                            />
                        }
                    </div>
                    <h4 className='mainColor font-weight-bold mt-3' >{translate('web.passportDetails', 'Passport Details')}</h4>
                    <div className="col-lg-6 col-md-6 col-sm-12 mt-2">
                        <NetaqInput
                            key={'IDTYPE'}
                            type={"text"}
                            label={translate("web.passportNumber", "Passport Number")}
                            placeholder={'123456789123456'}
                            name={"idNumber"}
                            onChange={handleChange}
                            required={true}
                        />
                    </div>
                    <div className="col-lg-6 col-md-6 col-sm-12 mt-2">
                        <SimpleFileUpload accept="image/*,application/pdf" label={translate('web.passportCopy', 'Passport Copy')} required={true} isMulti={false} isServer={false} initialFiles={uploadedFiles} onChange={handleFilesUploaded} key={'ID UPLOAD'} />
                    </div>
                </div>
                <div className='row mx-0 my-3'>
                    <div className='col-12 ms-1 text-start '>
                        <div className='ms-auto' style={{ maxWidth: 250 }}>
                            {isSubmitting ?
                                <Loader /> :
                                <CustomButton key={'submit'} type="submit" onClick={submitForm} className="btn-success" htmlText={translate('web.signUp', 'SignUp')} />
                            }
                        </div>
                    </div>
                </div>
            </form>
        </>
    )
}
